import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { Header } from '@app/sections/header';
import { Strings } from '@app/constants';
import { useTable } from '@app/components/table';
import { useDialog, useRequestState, useSearch } from '@app/hooks';
import AssetsList from './assets-list';
import AddAssets from './add-assets';
import { getAssets } from '../slice';
import { selectAssetState } from '../selectors';
import { useAuthRolePermissions } from '@app/utils';

const AssetsListPage = () => {
  const tableProps = useTable();
  const editDialog = useDialog();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAssets());
  }, [dispatch]);

  const { data, loading } = useRequestState({
    stateSelector: selectAssetState,
    errorShown: true,
  });
  const searchProps = useSearch({
    data,
    fields: ['assetUser', 'assetName', 'id', 'otherAssetName', 'purchaseDate'],
  });
  const { hasPermission } = useAuthRolePermissions();
  const canAddAsset = hasPermission('Assets', 'w');
  return (
    <>
      <Header
        title={Strings.sidebar.assets}
        helperText={''}
        actionButtonTitle={canAddAsset ? Strings.button.addAsset : undefined}
        searchBarProps={{
          placeholder: Strings.common.search,
          onChange: searchProps.handleSearchChange,
        }}
        onClickActionButton={editDialog.show}
      />

      <AssetsList
        tableProps={tableProps}
        rows={searchProps.filteredRows}
        loading={loading}
        canAddAsset={canAddAsset}
      />

      {editDialog.visible && <AddAssets open onClose={editDialog.hide} />}
    </>
  );
};

export { AssetsListPage };
